import { GroupingCodeComboBoxModel } from '../grouping-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ECグルーピングリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetGroupingCodeListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetGroupingCodeListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: GroupingCodeComboBoxModel;
  private groupingDiv142: string = null;
  private groupingDiv163: string = null;
  private groupingDiv185: string = null;
  private groupingDiv240: string = null;
  private groupingDiv210: string = null;
  private groupingDiv302: string = null;
  private groupingDiv515: string = null;
  private groupingDiv451: string = null;
  private groupingDiv454: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGroupingCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        GroupingDiv142: this.groupingDiv142,
        GroupingDiv163: this.groupingDiv163,
        GroupingDiv185: this.groupingDiv185,
        GroupingDiv240: this.groupingDiv240,
        GroupingDiv210: this.groupingDiv210,
        GroupingDiv302: this.groupingDiv302,
        GroupingDiv515: this.groupingDiv515,
        GroupingDiv451: this.groupingDiv451,
        GroupingDiv454: this.groupingDiv454
      }
    });;
  }
  /**
   * API呼び出し
   *
   * @param {GroupingCodeboBoxModel} model
   * @param {string} groupingDiv142 グルーピング区分・いばらき
   * @param {string} groupingDiv163 グルーピング区分・とちぎ
   * @param {string} groupingDiv185 グルーピング区分・ぐんま
   * @param {string} groupingDiv240 グルーピング区分・ちば
   * @param {string} groupingDiv210 グルーピング区分・さいたま
   * @param {string} groupingDiv302 グルーピング区分・とうきょう
   * @param {string} groupingDiv515 グルーピング区分・ながの
   * @param {string} groupingDiv451 グルーピング区分・にいがた
   * @param {string} groupingDiv454 グルーピング区分・クルコ
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetGroupingCodeListService
   */
  execute(model: GroupingCodeComboBoxModel,
    groupingDiv142: string,
    groupingDiv163: string,
    groupingDiv185: string,
    groupingDiv240: string,
    groupingDiv210: string,
    groupingDiv302: string,
    groupingDiv515: string,
    groupingDiv451: string,
    groupingDiv454: string,
    successFunc: Function = null) {
    this.model = model;
    this.groupingDiv142 = groupingDiv142;
    this.groupingDiv163 = groupingDiv163;
    this.groupingDiv185 = groupingDiv185;
    this.groupingDiv240 = groupingDiv240;
    this.groupingDiv210 = groupingDiv210;
    this.groupingDiv302 = groupingDiv302;
    this.groupingDiv515 = groupingDiv515;
    this.groupingDiv451 = groupingDiv451;
    this.groupingDiv454 = groupingDiv454;
    this.successFunc = successFunc;
    this.send('KYMW02getGroupingList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingCodeListService
   */
  success(data: any) {
    this.model.updateGroupingList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
